import React from 'react';
import { TRANSLATIONS } from '../../translations';

interface GuestLimitModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  language: 'en' | 'pl';
  onLoginSignUp: () => void;
}

export function GuestLimitModal({ showModal, setShowModal, language, onLoginSignUp }: GuestLimitModalProps) {
  const t = TRANSLATIONS[language];

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-slate-900 p-8 rounded-xl shadow-2xl border border-slate-200 dark:border-slate-800 w-full max-w-md relative text-center">
        <button
          onClick={() => setShowModal(false)}
          className="absolute top-4 right-4 text-slate-500 hover:text-slate-700 dark:hover:text-slate-300"
        >
          X
        </button>
        <h2 className="font-heading text-xl font-bold text-orange-700 mb-4">{t.guestLimitExceeded}</h2>
        <p className="text-slate-600 dark:text-slate-300 mb-6">{t.loginToSaveWorkouts}</p>
        <button
          onClick={() => {
            setShowModal(false);
            onLoginSignUp();
          }}
          className="w-full bg-orange-600 text-white py-3 rounded-lg font-bold hover:bg-orange-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
        >
          {t.loginSignUp}
        </button>
      </div>
    </div>
  );
}
